export const APP_WIDTH_CAP = "max-w-[1536px] w-full mx-auto";

// Single source of truth for the outer frame of every dashboard/onboarding
// page (width cap + horizontal + vertical rhythm). Use this constant in markup
// for every page container. Add a `space-y-*` utility alongside it for
// inter-section rhythm.
export const PAGE_FRAME = `px-4 sm:px-6 pt-8 sm:pt-10 pb-8 sm:pb-12 ${APP_WIDTH_CAP}`;
